import React, { useState } from 'react';
import { Card, Avatar, Typography, Space, Button, Descriptions, Modal, Form, Input, message } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import Header from '../../components/Header'; // 引入你的Header
import Footer from '../../components/Footer'; // 引入你的Footer
import './index.css';

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

// 初始用户信息
const initialUserInfo = {
  avatar: 'https://tse2-mm.cn.bing.net/th/id/OIP-C.-MY8NwkQbUXDqC5bDx3cRAHaHa?w=186&h=186&c=7&r=0&o=7&cb=ucfimg2&dpr=1.5&pid=1.7&rm=3&ucfimg=1',
  nickname: 'Lu tang-tang',
  welcome: 'Hi，我是 Lu tang-tang！',
  intro: '这个人格缺陷，什么也不会下。',
  blogIntro: '欢迎来我的博客呀！希望你能看到的个人信息！',
  email: '2908897472@gmail.com',
  techStack: '暂无',
  hobby: '暂无',
  github: '暂无',
  lifeQuestion: '（可选）'
};

const About = ({ loggedInUser, onLogout }) => { // 接收Header所需参数
  const [userInfo, setUserInfo] = useState(initialUserInfo);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();

  // 点击编辑：回显当前用户信息
  const handleEdit = () => {
    form.setFieldsValue(userInfo);
    setModalVisible(true);
  };

  // 提交编辑：校验并更新信息（自动同步welcome字段）
  const handleSubmit = async () => {
    try {
      const editedValues = await form.validateFields();
      // 自动生成welcome字段，无需手动编辑
      const newUserInfo = {
        ...userInfo,
        ...editedValues,
        welcome: `Hi，我是 ${editedValues.nickname}！`
      };
      setUserInfo(newUserInfo);
      setModalVisible(false);
      message.success('个人信息编辑成功！');
    } catch (errorInfo) {
      console.error('表单校验失败：', errorInfo);
      message.error('请完善必填项后提交！');
    }
  };

  // 修复：自定义验证提示（按字段匹配精准提示）
  const validateMessages = {
    required: (_, { field }) => {
      // 字段名和标签的映射
      const fieldLabelMap = {
        avatar: '头像(URL)',
        nickname: '姓名/昵称',
        intro: '个人简介',
        blogIntro: '博客简介',
        email: '联系邮箱'
      };
      return `${fieldLabelMap[field] || '该字段'}为必填项！`;
    },
    email: () => '联系邮箱格式不正确！'
  };

  return (
    <div className="about-page">
      {/* 引入你的Header */}
      <Header loggedInUser={loggedInUser} onLogout={onLogout} />
      
      {/* 外层居中容器 */}
      <div className="about-container">
        <Card className="about-card" bordered={false} style={{ borderRadius: 8 }}>
          <div className="about-header">
            <Space align="center" wrap={true}>
              <Avatar 
                src={userInfo.avatar} 
                size={64} 
                className="about-avatar"
                fallback="Lu"
              />
              <div className="about-name-wrap">
                <Title level={3} className="about-nickname" style={{ margin: 0 }}>
                  {userInfo.welcome}
                </Title>
                <Paragraph type="secondary" style={{ margin: '4px 0' }}>
                  昵称：{userInfo.nickname}
                </Paragraph>
              </div>
              <Button 
                type="default" 
                icon={<EditOutlined />} 
                onClick={handleEdit}
                style={{ marginLeft: 'auto' }}
              >
                编辑个人信息
              </Button>
            </Space>
          </div>

          <div className="about-intro">
            <Title level={4} style={{ margin: '16px 0 8px 0' }}>个人简介</Title>
            <Paragraph style={{ margin: 0 }}>{userInfo.intro}</Paragraph>
            
            <Title level={4} style={{ margin: '16px 0 8px 0' }}>博客简介</Title>
            <Paragraph style={{ margin: 0 }}>{userInfo.blogIntro}</Paragraph>
          </div>

          <div className="about-contacts" style={{ marginTop: 20 }}>
            <Title level={4} style={{ margin: '0 0 16px 0' }}>联系信息</Title>
            <Descriptions 
              bordered 
              column={{ xs: 1, sm: 2 }} 
              size="middle"
            >
              <Descriptions.Item label="邮箱" style={{ wordBreak: 'break-all' }}>
                {userInfo.email}
              </Descriptions.Item>
              <Descriptions.Item label="技术栈">
                {userInfo.techStack || '暂无'}
              </Descriptions.Item>
              <Descriptions.Item label="兴趣爱好">
                {userInfo.hobby || '暂无'}
              </Descriptions.Item>
              <Descriptions.Item label="GitHub 链接">
                {userInfo.github || '暂无'}
              </Descriptions.Item>
              <Descriptions.Item label="个人生活的问题">
                {userInfo.lifeQuestion || '（可选）'}
              </Descriptions.Item>
            </Descriptions>
          </div>
        </Card>
      </div>

      {/* 引入你的Footer */}
      <Footer />

      {/* 编辑个人信息弹窗 */}
      <Modal
        title="编辑个人信息"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setModalVisible(false)}>
            取消
          </Button>,
          <Button key="submit" type="primary" onClick={handleSubmit}>
            提交
          </Button>
        ]}
        width={600}
        destroyOnClose={true}
        maskClosable={false}
      >
        {/* Form组件：修复validateMessages并补充完整闭合 */}
        <Form
          form={form}
          layout="vertical"
          initialValues={userInfo}
          validateMessages={validateMessages} // 使用修复后的验证提示
        >
          <Form.Item
            name="avatar"
            label="头像(URL)"
            rules={[{ required: true }]} // 提示由validateMessages统一管理
          >
            <Input 
              placeholder="请输入头像图片的URL地址" 
              style={{ maxWidth: '100%' }}
            />
          </Form.Item>

          <Form.Item
            name="nickname"
            label="姓名/昵称"
            rules={[{ required: true }]}
          >
            <Input placeholder="请输入你的姓名/昵称" />
          </Form.Item>

          <Form.Item
            name="intro"
            label="个人简介"
            rules={[{ required: true }]}
          >
            <TextArea rows={3} placeholder="请输入个人简介" />
          </Form.Item>

          <Form.Item
            name="blogIntro"
            label="博客简介"
            rules={[{ required: true }]}
          >
            <TextArea rows={3} placeholder="请输入博客简介" />
          </Form.Item>

          <Form.Item
            name="email"
            label="联系邮箱"
            rules={[
              { required: true },
              { type: 'email' }
            ]}
          >
            <Input placeholder="请输入你的联系邮箱" />
          </Form.Item>

          <Form.Item
            name="techStack"
            label="技术栈"
          >
            <Input placeholder="请输入你的技术栈（如：React、AntD）" />
          </Form.Item>

          <Form.Item
            name="hobby"
            label="兴趣爱好"
          >
            <Input placeholder="请输入你的兴趣爱好" />
          </Form.Item>

          <Form.Item
            name="github"
            label="GitHub链接"
          >
            <Input placeholder="请输入你的GitHub链接" />
          </Form.Item>

          <Form.Item
            name="lifeQuestion"
            label="个人生活的问题(可选)"
          >
            <Input placeholder="请输入个人生活的问题（可选）" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default About;